import { fetchAction } from "../utilities"; 

export const nonProfitTracker = (csrfToken, listId, donationPerEntry, minDonation, goal) => ({
    raised: 0,
    minDonation: minDonation,
    goal: goal,
    get percentRaised() {
        let percentage = Math.round((this.raised / this.goal) * 100)
        return `${percentage}%`
    },
    tweenNumber(start, end, duration = 2000) {
        const startTime = performance.now()
        const difference = end - start
        
        const animate = (currentTime) => {
            const elapsed = currentTime - startTime
            const progress = Math.min(elapsed / duration, 1)
            
            // Ease out cubic function for smooth deceleration
            const easeProgress = 1 - Math.pow(1 - progress, 3)
            
            this.raised = Math.round(start + (difference * easeProgress))
            
            if (progress < 1) {
                requestAnimationFrame(animate)
            }
        }
        
        requestAnimationFrame(animate)
    },
    async fetchListCount() {
        const requestUrl = "/actions/expansion/account/get-list-count"
        const body = JSON.stringify({
            listId: listId,
        })
        const response = await fetchAction(requestUrl, "POST", csrfToken, body)

        if (response.isSuccessful) {
            let donationVal = donationPerEntry * response.successData.count
            let finalDonation = minDonation + donationVal
            let newRaised = parseInt(finalDonation)
            
            // Tween from current value to new value
            if (newRaised !== this.raised) {
                this.tweenNumber(this.raised, newRaised)
            }
        } else {
            console.error("Failed to retrieve list:", error)
        }
    },
    async init() {
        // Initial fetch
        await this.fetchListCount()
        
        // Set up interval to fetch every 1 minute
        setInterval(() => {
            this.fetchListCount()
        }, 10000)
    }
})